import {
  KalturaAsset,
  KalturaCategoryTree,
  KalturaFilterPagerArgs,
  KalturaSearchAssetFilterArgs,
} from '@kaltura-ott/ott-client-types/api/types';
import { map, mergeMap, tap } from 'rxjs/operators';

import { getAssetsByFilter } from '../asset';
import { getCategoryTree } from '../category.tree';

import { getCategoryStructsList } from './category-template';

const getCategoryIds = (tree: KalturaCategoryTree, catIds: number[] = []) => {
  if (!catIds.length) {
    catIds.push(tree.id);
  }
  if (tree.children.length === 0) {
    return catIds;
  }
  tree.children.forEach((subTree) => {
    catIds.push(subTree.id);
    getCategoryIds(subTree, catIds);
  });
  return catIds;
};
const problematicItems: KalturaCategoryTree[] = [];
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const assignAssetsToCategories = (tree: any, assets: any, typesMapping: any) => {
  if (!tree.typeSystemName) {
    // @ts-expect-error TODO Fix
    tree.asset = assets.find((a) => a.metas.CategoryId.value === parseInt(tree.id, 10));
    tree.typeSystemName = typesMapping[tree.asset.type];
  }
  if (tree.children.length === 0) {
    return tree;
  }
  // @ts-expect-error TODO Fix
  tree.children.forEach((subTree) => {
    try {
      subTree.oldParentId = tree.id;
      // @ts-expect-error TODO Fix
      subTree.asset = assets.find((a) => a.metas.CategoryId.value === parseInt(subTree.id, 10));
      subTree.asset.typeSystemName = typesMapping[subTree.asset.type];
    } catch (e) {
      problematicItems.push(subTree);
      // throw new Error(e)
    }
    assignAssetsToCategories(subTree, assets, typesMapping);
  });
  return tree;
};

interface TypesMapping {
  [key: number]: string;
}

export const exportCategoryTree = (id: number) => {
  let originalTree: KalturaCategoryTree;

  return getCategoryTree(id).pipe(
    map((tree) => {
      originalTree = tree;
      return getCategoryIds(tree);
    }),
    mergeMap((catIds) => {
      const filter: KalturaSearchAssetFilterArgs = {
        kSql: `(and (or ${catIds.map((id) => `CategoryId = '${id}' `).join('')})(or ))`,
      };
      const pager: KalturaFilterPagerArgs = {
        pageSize: catIds.length,
        pageIndex: 1,
      };
      return getAssetsByFilter(filter, pager).pipe(map((resp) => resp.objects));
    }),
    mergeMap((assets: KalturaAsset[]) => {
      const structTypes = assets.map((s) => s.type);
      return getCategoryStructsList({ idIn: structTypes.join(',') }).pipe(
        map((response) => {
          const typesMapping: TypesMapping = {};
          response.objects.forEach((struct) => {
            typesMapping[struct.id] = struct.systemName;
          });
          return typesMapping;
        }),
        map((typesMapping) => {
          return assignAssetsToCategories(originalTree, assets, typesMapping);
        }),
      );
    }),
    tap(() => {
      console.log(JSON.stringify(problematicItems, null, 2));
    }),
  );
};
